export default "__VITE_ASSET__DDfi3ptn__";